export enum NetworkErrorWhiteList {
    AbortController = 'AbortController',
}
